<template>
	<f7-tab
		id="flow-from_bromoney"
		:tab-active="flow === CreatePaymentFlow.fromBromoney"
	>
		<div
			v-if="warningForBromoneyBlocks.length"
			class="new-payment-view__warning"
		>
			<FirebaseBlockWarning
				v-for="(block, index) in warningForBromoneyBlocks"
				:key="index"
				:loading="!account"
				:message="block"
			/>
		</div>
		<template v-if="account?.wallet && account.wallet.balance.currency">
			<PaymentInputAmount />
			<div class="hint">
				<p class="text">{{ $t('newPayment.from-bromoney-flow.hint') }}
					<span>{{ account.wallet.balance.amount }} {{account.wallet.balance.currency.abbr }}</span>
				</p>
			</div>
		</template>
	</f7-tab>
</template>

<script setup lang="ts">

import NewPaymentController, {CreatePaymentFlow} from "@/views/payment-create-config/NewPaymentController";
import FirebaseBlockWarning from "@components/atomic/block-warning/FirebaseBlockWarning.vue";
import PaymentInputAmount from "@/views/payment-create-config/comps/PaymentInputAmount.vue";

const viewController = NewPaymentController.getInstance();

const {
	flow,
	account,
	warningForBromoneyBlocks,
} = viewController;
</script>
